import React from "react";
import ExtraResumeSections from "./ExtraResumeSections";

const RING_PCTS = [90, 82, 75, 95, 68, 85, 78, 72];

function Ring({ pct, accent, label }) {
  const r = 16, c = 2 * Math.PI * r;
  return (
    <div className="flex flex-col items-center w-16">
      <svg width="40" height="40" viewBox="0 0 40 40">
        <circle cx="20" cy="20" r={r} fill="none" stroke="#e2e8f0" strokeWidth="4" />
        <circle cx="20" cy="20" r={r} fill="none" stroke={accent} strokeWidth="4" strokeDasharray={c} strokeDashoffset={c - (c * pct) / 100} strokeLinecap="round" transform="rotate(-90 20 20)" />
      </svg>
      <p className="text-[10px] text-slate-600 text-center mt-1 truncate w-full">{label}</p>
    </div>
  );
}

export default function SkillRingsTemplate({ draft, accent }) {
  return (
    <div className="bg-white text-slate-900 rounded-xl p-8 shadow-2xl text-[13px] leading-relaxed" data-testid="resume-live-preview">
      <h1 className="text-2xl font-bold">{draft.full_name || "Your Name"}</h1>
      {draft.target_role && <p className="text-sm font-semibold mt-0.5" style={{ color: accent }}>{draft.target_role}</p>}
      <p className="text-slate-500 text-[11px] mt-2">{[draft.contact_email, draft.contact_phone, draft.location].filter(Boolean).join("  •  ")}</p>
      <div className="w-full h-px bg-slate-200 my-4" />

      {draft.summary && <p className="text-slate-700 mb-4">{draft.summary}</p>}

      {draft.experience.length > 0 && (
        <div className="mb-4">
          <h2 className="text-xs font-bold uppercase tracking-wider mb-2" style={{ color: accent }}>Experience</h2>
          {draft.experience.map((e, i) => (
            <div key={i} className="mb-2.5">
              <p className="font-semibold text-slate-800">{e.title} — {e.company}</p>
              <ul className="list-disc list-inside text-slate-700 mt-0.5">{e.bullets.filter(Boolean).map((b, bi) => <li key={bi}>{b}</li>)}</ul>
            </div>
          ))}
        </div>
      )}
      {draft.skills.length > 0 && (
        <div className="mb-4">
          <h2 className="text-xs font-bold uppercase tracking-wider mb-2" style={{ color: accent }}>Skills</h2>
          <div className="flex flex-wrap gap-2">{draft.skills.map((sk, i) => <Ring key={sk} pct={RING_PCTS[i % RING_PCTS.length]} accent={accent} label={sk} />)}</div>
        </div>
      )}
      {draft.education.length > 0 && (
        <div className="mb-4">
          <h2 className="text-xs font-bold uppercase tracking-wider mb-2" style={{ color: accent }}>Education</h2>
          {draft.education.map((ed, i) => <p key={i} className="text-slate-700">{ed.degree} {ed.field} — {ed.school}</p>)}
        </div>
      )}
      <ExtraResumeSections draft={draft} accent={accent} />
    </div>
  );
}
